import { useMemo, useRef, useState } from 'react';

import { useAppDispatch, useAppSelector } from '../../../../lib/store';
import { useGetAnnotatorsQuery } from '../../api/createProjectApiSlice';
import {
  addSelectedAnnotator,
  AnnotationUser,
  removeSelectedAnnotator,
} from '../../state/createProjectSlice';
import { selectSelectedAnnotators } from '../../state/selector';
import { AnnotatorResponse } from '../../types/response';

interface UseAnnotatorsSelectionResults {
  annotators: AnnotatorResponse[];
  selectedAnnotators: AnnotationUser[];
  handleAddAnnotator: (annotator: AnnotatorResponse) => void;
  handleRemoveAnnotator: (annotator: AnnotatorResponse) => void;
  annotatorInputValue: string;
  lastTypedAnnotatorValue: React.MutableRefObject<string>;
  setAnnotatorInputValue: (value: string) => void;
  isAnnotatorsLoading: boolean;
}

export const useAnnotatorsSelection = (): UseAnnotatorsSelectionResults => {
  const {
    data: annotatorsData,
    isLoading: isAnnotatorsLoading,
    isFetching: isAnnotatorsFetching,
  } = useGetAnnotatorsQuery();
  const annotators = useMemo(() => annotatorsData?.data ?? [], [annotatorsData]);

  const dispatch = useAppDispatch();
  const selectedAnnotators = useAppSelector(selectSelectedAnnotators);
  const handleAddAnnotator = (annotator: AnnotatorResponse) => {
    dispatch(addSelectedAnnotator(annotator));
  };
  const handleRemoveAnnotator = (annotator: AnnotatorResponse) => {
    dispatch(removeSelectedAnnotator(annotator.id));
  };
  const [annotatorInputValue, setAnnotatorInputValue] = useState<string>('');

  const lastTypedAnnotatorValue = useRef<string>('');
  return {
    selectedAnnotators,
    handleRemoveAnnotator,
    annotators,
    annotatorInputValue,
    lastTypedAnnotatorValue,
    setAnnotatorInputValue,
    handleAddAnnotator,
    isAnnotatorsLoading: isAnnotatorsLoading || isAnnotatorsFetching,
  };
};
